export default __webpack_public_path__ + "static/media/question.ccccd0b2.png";